export default __webpack_public_path__ + "static/breda-a0c660fff8c73c29f449009779f2169f.png";